import { ERoles } from '@enums';
import { useContext, useEffect } from 'react';
import { UserContext } from 'context/userContext';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import packageInfo from '../../package.json';
import { hasRole } from '@models';

const APP_VERSION = packageInfo.version;

export const Layout = () => {
  const location = useLocation();

  const { user, isLoading } = useContext(UserContext);
  const navigate = useNavigate();


  useEffect(() => {
    if (isLoading) return;

    if (['/', '/auth'].includes(location.pathname)) {
      if (user) {
        if (hasRole(user, ERoles.STORE)) {
          navigate('/store', { replace: true });
        } else if (hasRole(user, ERoles.STATS)) {
          navigate('/stats', { replace: true });
        } else if (hasRole(user, ERoles.VALIDATOR)) {
          navigate('/validator', { replace: true });
        } else {
          navigate('/auth', { replace: true });
        }
      } else {
        navigate('/auth', { replace: true });
      }
    }
  }, [user, isLoading, location.pathname, navigate]);

  return (
    <div className={location.pathname !== '/auth' ? 'd-block d-lg-flex' : ''}>
      <div className="w-100 min-vh-100 d-flex flex-column">
        <div className="flex-grow-1">
          <Outlet />
        </div>
        <footer className="text-center text-white text-xs py-2 bg-primary">v{APP_VERSION}</footer>
      </div>
    </div>
  );
};
